module.exports = __webpack_public_path__ + "img/loading.308a7a2e.gif";